export const DEFAULT_CEPIK_INSURERS: string[] = [
  'balcia',
  'direct',
  'wiener',
  'ergo',
  'ergo-lite',
  'mtu',
  'mtu24',
  'ominimo',
  'ycd',
];
